import { ALL_JOB_SWMS_FORM_DROPDOWN_URL, SWMS_FORM_URL, SWMS_FORM_HIGH_RISK_DATA_URL, GET_EMAIL_CONTENT_URL, SLUG_EMAIL_CONTENT_URL, SWMS_EMAIL_TO_CLIENT_URL, SWMS_SHIFTS_URL, CALENDAR_ACCOUNT_MANAGERS_URL, ALL_JOB_SWMS_URL } from "../../dataProvider/constant";
import { baseApiInstance, scopeApiInstance } from "../../dataProvider/axiosHelper";
import { Strings } from "../../dataProvider/localize";

export const getAllSwmsDropdowns = (abortController) => () => {
  return scopeApiInstance.get(ALL_JOB_SWMS_FORM_DROPDOWN_URL, { ...abortController }).then((res) => {
    if (res && res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const getSwmsFormData = (abortController, id, jobId) => () => {
  if (id === undefined || id === null || `${id}`.trim() === "" || jobId === undefined || jobId === null || `${jobId}`.trim() === "") {
    return Promise.reject(Strings.generic_error);
  }

  const url = `${ALL_JOB_SWMS_URL}/${jobId}/${id}`;
  const config = { ...abortController };

  return scopeApiInstance.get(url, config).then(res => {
    if (res && res.data && res.data.data) {
      const responseData = res.data.data;
      const normalizedSwmsData = responseData && responseData.document
        ? responseData.document
        : (responseData && responseData.swms_data ? responseData.swms_data : null);

      return Promise.resolve({
        ...responseData,
        swms_data: normalizedSwmsData
      });
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const getAllHighRisksData = (abortController) => () => {
  return scopeApiInstance.get(SWMS_FORM_HIGH_RISK_DATA_URL, { ...abortController }).then((res) => {
    if (res && res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const saveSwmsForm = (jobId, swmsId, formData) => () => {
  if (jobId === undefined || jobId === null || `${jobId}`.trim() === "" || swmsId === undefined || swmsId === null || `${swmsId}`.trim() === "") {
    return Promise.reject(Strings.generic_error);
  }

  return scopeApiInstance.put(`${ALL_JOB_SWMS_URL}/${jobId}/${swmsId}`, formData).then(res => {
    if (res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.reject();
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const getEmailSwmsContent = (abortController) => () => {
  return baseApiInstance.get(SLUG_EMAIL_CONTENT_URL, { ...abortController, params: { slug: "swms_email_to_client" } }).then(res => {
    if (res && res.data && res.data.data && res.data.data.result && res.data.data.result.length === 1) {
      return Promise.resolve(res.data.data.result[0]);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const sendSwmsEmail = (formData) => () => {
  return scopeApiInstance.post(SWMS_EMAIL_TO_CLIENT_URL, formData).then(res => {
    if (res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.reject();
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const getSwmsShifts = (abortController, params = {}, page = 1) => () => {
  return scopeApiInstance.get(SWMS_SHIFTS_URL, { ...abortController, params: { page, ...params, limit: 15 } }).then((res) => {
    if (res && res.data && res.data.data) {
      return Promise.resolve(res.data.data.swmsShifts);
    } else {
      return Promise.reject(Strings.generic_error);
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const attachSwmsToShifts = (formData) => () => {
  return scopeApiInstance.put(SWMS_SHIFTS_URL, formData).then(res => {
    if (res.data && res.data.message) {
      return Promise.resolve(res.data.message);
    } else {
      return Promise.reject();
    }
  }).catch(error => {
    if (error) {
      return Promise.reject(
        error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
      );
    } else {
      return Promise.reject(null);
    }
  })
}

export const getAccountManagers = (organisationId) => () => {
  let url = `${CALENDAR_ACCOUNT_MANAGERS_URL}?organisation_id=${organisationId}&fetch_all=1`;
  return baseApiInstance.get(url).then((res) => {
    if (res && res.data && res.data.data && res.data.data.account_managers) {
      return Promise.resolve(res.data.data.account_managers);
    } else {
      return Promise.reject();
    }
  }).catch(error => {
    return Promise.reject(
      error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
    );
  })
}